import script from "./Nav.vue?vue&type=script&setup=true&lang=ts"
export * from "./Nav.vue?vue&type=script&setup=true&lang=ts"

import "./Nav.vue?vue&type=style&index=0&id=53a1a91d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53a1a91d"]])

export default __exports__